import { ChildProps } from '@/common/util/props'

const CenterMain = ({ children }: ChildProps) => {
  return <main className='grid place-items-center gap-1 pt-20'>{children}</main>
}

export default CenterMain
